export enum State {
  Error = -1,
  InProgress = 0,
  UploadCompleted = 1,
  ResultReady = 2,
  AbortedByUser = 254,
  AbortedBySystem = 255,
  WineInProgress = 3,
  FermentationOngoing = 4,
  UserFermentationCompleted = 5,
  FermentationComplete = 6,
  WineUploadCompleted = 7,
  WineResultReady = 8,
  WineResultReadyDisabled = 9,
  ResultReadyDisabled = 10,
}

export const ResultReadyStates = [
  State.ResultReady,
  State.WineResultReady,
  State.ResultReadyDisabled,
  State.WineResultReadyDisabled,
];

export const NonDisabledReadyStates = [State.ResultReady, State.WineResultReady];
